window.addEventListener('DOMContentLoaded', ()=>{
    
    let sidebar =  document.getElementById('sidebar');

    if( sidebar ){

        let filters = document.querySelectorAll('.wp-block-woocommerce-filter-wrapper .wp-block-heading');

        if( filters ){
            filters.forEach( filter => filter.addEventListener( 'click', e => e.currentTarget.classList.toggle('closed')));
        }

        // Open active filters on load

        const observer = new MutationObserver(openFilters);
        
        observer.observe(sidebar, {
            attributes: true, 
            childList: true, 
            subtree: true
        });


        // mobile filter button
        const filterButton = document.querySelector('.product-filter-button');
        if(filterButton){
            filterButton.addEventListener( 'click', toggleSidebar );
            window.addEventListener('resize',sidebarHandleResize );
        }

        function toggleSidebar(){
            sidebar.classList.toggle('open');
        }

        function sidebarHandleResize(){

            const mobileBreakpoint = 900;

            if( true == window.matchMedia(`(min-width: ${mobileBreakpoint}px)`).matches ){
                sidebar.classList.remove('open');
            }

        }

    }

})

// Waits for Woo to inject the code and open the dropdows that have checked inputs
const openFilters = (mutationList, observer) => {
    for (const mutation of mutationList) {
        if (mutation.type === "attributes") {
            if( 'hidden' == mutation.attributeName ){
                let active = document.querySelectorAll('.wp-block-woocommerce-filter-wrapper:has(input:checked)');
                if(active){
                    active.forEach( filter => filter.querySelector('.wp-block-heading').classList.remove('closed') );
                }
                observer.disconnect();
            }
        }
    }
};